import React from "react";
import EnhanceFooter from "./EnhanceFooter";
import BottomBar from "./BottomBar";
import Legislation from "./Legislation";
import UserQuery from "../Header/UserQuery.gql";

const Footer = (props) => {
  return (
    <footer>
      <BottomBar
        categories={props.categories}
        accountDetails={props.accountDetails}
        contact={props.contact}
        user={props.me.me}
      />
      <Legislation />
    </footer>
  );
};

const SmartFooter = EnhanceFooter({ UserQuery })(Footer);

export default SmartFooter;
